import { FilterMethod } from '@dbl/core/filter';
import { FilterCountyEntry } from "./filters/FilterCountyEntry";
import { FilterNoneEntry } from "./filters/FilterNoneEntry";
import { FilterNumberEntry } from "./filters/FilterNumberEntry";
import { FilterPackageEntry } from "./filters/FilterPackageEntry";
import { FilterStringEntry } from "./filters/FilterStringEntry";
import { FilterTimeEntry } from "./filters/FilterTimeEntry";
import { FilterDateEntry } from "./filters/FilterDateEntry";
import { FilterNewStringEntry } from "./filters/FilterNewStringEntry";
import { FilterGroupCascadeEntry } from "./filters/FilterGroupCascadeEntry";

export const FilterEntryMap = {
  [FilterMethod.None]: FilterNoneEntry,
  [FilterMethod.Time]: FilterTimeEntry,
  [FilterMethod.County]: FilterCountyEntry,
  [FilterMethod.String]: FilterStringEntry,
  [FilterMethod.Number]: FilterNumberEntry,
  [FilterMethod.Package]: FilterPackageEntry,
};

export const ABExperimentFilterEntryMap = {
  [FilterMethod.None]: FilterNoneEntry,
  [FilterMethod.String]: FilterNewStringEntry,
  [FilterMethod.Date]: FilterDateEntry,
  [FilterMethod.GroupCascade]: FilterGroupCascadeEntry,
};

export const FilterOperationMap = {
  [FilterMethod.None]: '',
  [FilterMethod.Time]: 'between',
  [FilterMethod.County]: 'include',
  [FilterMethod.String]: '',
  [FilterMethod.Number]: '',
  [FilterMethod.Package]: '',
};

export const dtStatDate = 'dtStatDate';
export const FilterBasic = [
  {
    table_id: '',
    column_name: dtStatDate,
    column_display: '统计时间',
    column_display_en: 'statisticalTime',
    column_granularity: 'Day',
    column_type: 'date',
    filter_method: FilterMethod.Time,
    column_value: [],
  },
  // {
  //   table_id: '',
  //   column_display: '注册国家',
  //   column_name: 'regCountry',
  //   column_type: 'string',
  //   filter_method: FilterMethod.County,
  //   column_value: [],
  // },
];
